import { render, staticRenderFns } from "./action-scroll-to-top.vue?vue&type=template&id=24f7ccf5&"
import script from "./action-scroll-to-top.vue?vue&type=script&lang=js&"
export * from "./action-scroll-to-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports